<div class="modal-container">
  <button
    id="modalInteraccion"
    #modalInteraccion
    data-bs-toggle="modal"
    data-bs-target="#ModelInt"
    hidden="hidden">
    Launch
  </button>
  <div
    class="modal fade"
    id="ModelInt"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title h5-tipografia-govco">
            Configuración de interacción
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            (click)="resetForm()"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3" *ngIf="esTipo">
            <label for="tipoInteraccion" class="form-label"
              >Tipo de interacción</label
            >
            <select
              [id]="tipoInteraccion"
              class="form-select"
              (change)="onChangeTipoInteraccion($event)">
              <option
                value="Díalogo"
                [selected]="tipoInteraccion === 'Díalogo'">
                Díalogo
              </option>
              <option
                value="Llamada a equipo"
                [selected]="tipoInteraccion === 'Llamada a equipo'">
                Llamada a equipo
              </option>
              <option
                *ngIf="isTools"
                value="Uso de herramienta"
                [selected]="tipoInteraccion === 'Uso de herramienta'">
                Uso de herramienta
              </option>
              <option
                value="Salta a"
                [selected]="tipoInteraccion === 'Salta a'">
                Salta a
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label for="actor" class="form-label">Modo de interacción</label>
            <select
              [id]="actor"
              class="form-select"
              (change)="onChangeActor($event)">
              <ng-container *ngIf="editFlag === true">
                <!-- Es edicion -->
                <option
                  value="Des. Usuario"
                  [selected]="interaccion?.actor === 'Des. Usuario'"
                  *ngIf="
                    interaccion?.tipo != 'Llamada a equipo' &&
                    interaccion?.tipo != 'Respuesta de equipo'
                  ">
                  Des. Usuario
                </option>
                <option
                  value="Instrucción"
                  [selected]="interaccion?.actor === 'Instrucción'">
                  Instrucción
                </option>
              </ng-container>
              <ng-container *ngIf="editFlag === false">
                <!-- Es creacion -->
                <option
                  value="Des. Usuario"
                  [selected]="actor === 'Des. Usuario'">
                  Des. Usuario
                </option>
                <option
                  value="Instrucción"
                  [selected]="actor === 'Instrucción'">
                  Instrucción
                </option>
              </ng-container>
            </select>
          </div>
          <ng-container *ngIf="tipoInteraccion === 'Llamada a equipo'">
            <div class="mb-2">
              <label for="equipo" class="form-label">Equipo</label>
              <select
                [id]="equipo"
                class="form-select"
                (change)="onChangeEquipo($event)">
                <option
                  *ngFor="let eq of listaEquipos"
                  placeholder="Seleccione un equipo"
                  [selected]="eq.Nombre === equipo"
                  [value]="eq.Nombre">
                  {{ eq.Nombre }}
                </option>
              </select>
            </div>
          </ng-container>
          <ng-container *ngIf="esHerramienta">
            <div class="mb-2">
              <label for="herramienta" class="form-label">Herramienta</label>
              <select
                [id]="herramienta"
                class="form-select"
                (change)="onChangeHerramienta($event)">
                <option
                  *ngFor="let herramienta of herramientas"
                  placeholder="Seleccione una herramienta"
                  [value]="herramienta.Id">
                  {{ herramienta.Nombre }}
                </option>
              </select>
            </div>
          </ng-container>
          <ng-container *ngIf="tipoInteraccion === 'Salta a'">
            <div class="mb-2">
              <label for="vertices" class="form-label">Pasos</label>
              <select
                [id]="vertices"
                class="form-select"
                (change)="onChangeVertice($event)">
                <option [selected]="true" [value]="null">
                  Seleccione un paso
                </option>
                <option
                  *ngFor="let vertice of vertices"
                  placeholder="Seleccione un paso"
                  [value]="vertice">
                  {{ vertice }}
                </option>
              </select>
            </div>
          </ng-container>
          <form [formGroup]="interaccionFormGroup" (ngSubmit)="submitForm()">
            <div class="row">
              <div
                *ngFor="let field of interaccionForm"
                class="col-md-{{ field.width }}">
                <div class="mb-3">
                  <label [for]="field.name" class="form-label">{{
                    field.label
                  }}</label>
                  <!-- Text Input -->
                  <input
                    *ngIf="field.type === 'text'"
                    [id]="field.name"
                    [type]="field.type"
                    class="form-control"
                    [formControlName]="field.name" />
                  <!-- Textarea -->
                  <textarea
                    *ngIf="field.type === 'textarea'"
                    [id]="field.name"
                    class="form-control"
                    [formControlName]="field.name"
                    rows="3"></textarea>
                  <!-- Validation Error Messages -->
                  <div *ngIf="getErrorMessage(field.name)" class="text-danger">
                    {{ getErrorMessage(field.name) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3 d-flex gap-2">
              <button type="submit" class="btn-govco fill-btn-govco">
                Guardar
              </button>
              <button
                type="button"
                class="btn-govco btn-govco"
                (click)="resetForm()"
                data-bs-dismiss="modal">
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
